export default __webpack_public_path__ + "static/media/ChemicalReaction.b3f3aff7130c39558e85c76558da5752.webp";